import Config from './Config';

export * from './Config';

export default Config;
